export default __webpack_public_path__ + "static/media/lumos_brand_crop_dua.164f6b1b.jpg";